import React, { memo, useCallback, useContext, useRef, useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
} from "@mui/material";
import Popper from "@mui/material/Popper";
import Fade from "@mui/material/Fade";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import { useSelector } from "react-redux";
import { useLocation } from "react-router";
import AddIcon from "@mui/icons-material/Add";
import style from "./CommonPopper.module.css";
import { GlobalContextMain } from "../../Context/GloblaContext";
import { imageBaseURL } from "../../constants/utils";

const CommonPopper = ({
  open = false,
  actionExpanded = false,
  anchorEl = null,
  onClose = () => {},
  onClick = () => {},
  list = [],
  isList = false,
  placement = "right",
  width = "18%",
  id = "",
  sx,
  isApproval = null,
  isCreateCase = false,
  sxContainer,
  isDisabled = () => {},
  actionList = [],
  isHold = false,
  flagToViewAction = "true",
  flagToHideView = false,
}) => {
  const { isTabView } = useContext(GlobalContextMain);
  const ref = useRef(null);
  const location = useLocation();
  const [actionListOpen, setactionListOpen] = useState(false);
  const [hoverItem, setHoverItem] = useState(null);
  const activeSideBar = useSelector(
    (state) => state?.sidBarSliceMenu?.sideBarMenu
  );
  const onClickHandler = useCallback(
    (e, item) => {
      onClick(ref?.current, item);
    },
    [onClick]
  );
  const onMouseLeave = useCallback(() => {
    setHoverItem(null);
  }, []);
  const onMouseEnter = useCallback((value) => {
    setHoverItem(value);
  }, []);
  const onClosePopOver = useCallback(() => {
    setactionListOpen(false);
    onClose();
  }, [onClose]);
  const getPopperWidth = useCallback(() => {
    if (actionList?.length === 1) {
      return "20%";
    } else if (actionList?.length === 2) {
      return "33%";
    } else if (actionList?.length === 3) {
      return "47%";
    } else {
      return isTabView ? "23%" : "57.32%";
    }
  }, [actionList]);

  return (
    <>
      <Backdrop
        open={open}
        onClick={onClosePopOver}
        sx={{ zIndex: isList ? 15 : 5 }}
        transitionDuration={{
          exit: 300,
        }}
      />
      <Popper
        id={id}
        open={open}
        anchorEl={anchorEl}
        transition
        placement={isList ? "right-start" : placement}
        sx={{
          width:
            actionListOpen || actionExpanded
              ? getPopperWidth
              : flagToViewAction === "false"
                ? "10%"
                : "18%",
          zIndex: isList ? 20 : 10,
          ...sx,
          // transition: actionListOpen ? "0.5s" : "none",
        }}
        ref={ref}
      >
        {({ TransitionProps }) => (
          <Fade
            {...TransitionProps}
            timeout={{ appear: 350, enter: 350, exit: 0 }}
          >
            <Box
              sx={{
                display: "flex",
                width: "100%",
                justifyContent: "space-between",
              }}
              className="main-container"
            >
              {activeSideBar === "Invoice" ? (
                <Box
                  id="viewInvoice"
                  sx={{
                    bgcolor: "white",
                    borderRadius: "0.4rem",
                    marginLeft: "0.5rem",
                    padding: isList && !isApproval ? "1.4rem" : "none",
                    ...sxContainer,
                    height: "10%",
                    minHeight: "38px",
                  }}
                  className="view-container"
                >
                  <div
                    style={{
                      display: "inline-flex",
                      fontSize: "1.2rem",
                      fontWeight: "500",
                      lineHeight: "2.2rem",
                      cursor: "pointer",
                      alignItems: "center",
                      ...sxContainer,
                    }}
                    onClick={(e) => onClickHandler(e, "viewInvoice")}
                  >
                    <div style={{ padding: "0.8rem", display: "flex" }}>
                      <img
                        src={`${imageBaseURL}/Svg/viewAction.svg`}
                        alt="view button"
                        loading="lazy"
                      />
                    </div>
                    <div style={{ padding: "0.8rem" }}>View Invoice</div>
                  </div>
                </Box>
              ) : (
                <>
                  {!flagToHideView && (
                    <Box
                      id="view"
                      sx={{
                        // width: actionListOpen ? "11.43%" : "100%",
                        // width: "50%",
                        bgcolor: "white",
                        borderRadius: "4px 0 0 4px",
                        marginLeft: "0.5rem",
                        padding: isList && !isApproval ? "1.4rem" : "none",
                        paddingRight:
                          flagToViewAction === "false" ? "10px" : "",
                        ...sxContainer,
                        height: "10%",
                        minHeight: "38px",
                      }}
                      className="view-container"
                    >
                      <div
                        style={{
                          display: "inline-flex",
                          fontSize: "1.2rem",
                          fontWeight: "500",
                          lineHeight: "2.2rem",
                          cursor: "pointer",
                          alignItems: "center",
                          ...sxContainer,
                        }}
                        onClick={(e) => onClickHandler(e, "view")}
                      >
                        <div style={{ padding: "0.8rem", display: "flex" }}>
                          <img
                            src={`${imageBaseURL}/Svg/viewAction.svg`}
                            alt="view button"
                            loading="lazy"
                          />
                        </div>
                        <div style={{ padding: "0.8rem" }}>View</div>
                      </div>
                    </Box>
                  )}
                    {location.pathname !== "/createCase" && (
                      <Box
                        id="caseHistory"
                        sx={{
                          bgcolor: "white",
                          borderRadius:
                            flagToViewAction === "false"
                              ? "0px 4px 4px 0px"
                              : "0px",
                          ...sxContainer,
                          height: "auto",
                          minHeight: "38px",
                          display: "flex",
                          alignItems: "center",
                        }}
                        className="view-container"
                      >
                        <div
                          style={{
                            display: "inline-flex",
                            fontSize: "1.2rem",
                            fontWeight: "500",
                            lineHeight: "2.2rem",
                            cursor: "pointer",
                            alignItems: "center",
                            ...sxContainer,
                          }}
                          onClick={(e) => onClickHandler(e, "Case History")}
                        >
                          <div style={{ padding: "0.8rem", display: "flex" }}>
                            <img
                              src={`${imageBaseURL}/Svg/actionsIcon/case-description-action.svg`}
                              alt="case history icon"
                              loading="lazy"
                            />
                          </div>
                          <div style={{ padding: "0.8rem", whiteSpace: "nowrap" }}>
                            Case History
                          </div>
                        </div>
                      </Box>
                    )}
                  <Box
                    sx={{
                      bgcolor: flagToHideView ? "none" : "white",
                      borderRadius:
                        actionList?.length || flagToViewAction === "true"
                          ? 0
                          : "0 4px 4px 0",
                      // marginLeft: "0.5rem",
                      // padding: isList && !isApproval ? "1.4rem" : "none",
                      // ...sxContainer,
                      minHeight: "38px",
                      // width: "10%",
                      // padding:
                      //   flagToViewAction === "false"
                      //     ? ""
                      //     : flagToHideView
                      //       ? "1rem"
                      //       : "1.9rem",
                    }}
                  ></Box>
                  {/* {actionList?.length > 1 && ( */}
                  <Box
                    className="actions-container"
                    id="action"
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      width:
                        flagToViewAction === "false"
                          ? "0"
                          : flagToHideView
                            ? "60%"
                            : "100%",
                      bgcolor: "white",
                      borderRadius:
                        actionListOpen || actionExpanded
                          ? "0 4px 0 0"
                          : flagToHideView
                            ? "5px"
                            : "0 4px 4px 0",
                      padding: isList && !isApproval ? "1.4rem" : "none",
                      ...sxContainer,
                      fontSize: "1.2rem",
                      fontWeight: "500",
                      lineHeight: "2.2rem",
                      cursor: "pointer",
                    }}
                  >
                    {isCreateCase ? (
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          marginRight: "6px",
                          width: "100%",
                        }}
                      >
                        <div
                          style={{
                            display: "inline-flex",
                            fontSize: "1.2rem",
                            fontWeight: "500",
                            lineHeight: "2.2rem",
                            cursor: "pointer",
                            alignItems: "center",
                            width: "100%",
                            paddingLeft: flagToHideView ? "1rem" : "none",
                            ...sxContainer,
                          }}
                          onClick={(e) => onClickHandler(e, "createCase")}
                        >
                          <div
                            style={{
                              padding: "0.4rem",
                              display: "flex",
                              backgroundColor: "#FAFAFA",
                              borderRadius: "50%",
                              marginRight: "10px",
                            }}
                          >
                            <AddIcon fontSize="large"></AddIcon>
                          </div>
                          <div
                            style={{ padding: "0.2rem", width: "max-content" }}
                          >
                            Create Case
                          </div>
                        </div>
                      </Box>
                    ) : (
                      flagToViewAction !== "false" && (
                        <Accordion
                          defaultExpanded={actionExpanded}
                          sx={{
                            height: "38px",
                            margin: 0,
                            padding: 0,
                            border: "none",
                            borderRadius: "0 4px 4px 0",
                            boxShadow: "none",
                            // marginLeft: "36px",
                            width: "100%",
                          }}
                          TransitionProps={{
                            mountOnEnter: true,
                            unmountOnExit: true,
                            timeout: { enter: 0, exit: 195 },
                          }}
                          onChange={(e, expanded) => {
                            if (expanded) {
                              setactionListOpen(expanded);
                            } else {
                              setTimeout(() => {
                                setactionListOpen(expanded);
                              }, 100);
                            }
                          }}
                        >
                          <AccordionSummary
                            sx={{
                              minHeight: "38px",
                              borderRadius: "0 4px 4px 0",
                              height: "38px",
                              padding: 0,
                              justifyContent: "flex-end",
                              "&.Mui-expanded": {
                                minHeight: 0,
                                // marginLeft: "36px",
                              },
                              "& .MuiAccordionSummary-content": {
                                marginLeft: "1.2rem !important",
                              },
                            }}
                            // className={classes}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                p: {
                                  md: "0rem 0.8rem",
                                  sm: "1rem 0.8rem",
                                  xs: "1rem 0.8rem",
                                },
                              }}
                            >
                              <img
                                src={
                                  actionListOpen || actionExpanded
                                    ? `${imageBaseURL}/Svg/hoverActionsIcon/hoverActionHand.svg`
                                    : `${imageBaseURL}/Svg/handAction.svg`
                                }
                                alt="action view button"
                                loading="lazy"
                              />
                            </Box>

                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                p: {
                                  md: "0.8rem",
                                  sm: "0.8rem 0rem 0.8rem 0.8rem",
                                },
                              }}
                            >
                              Action
                            </Box>
                            <Box
                              sx={{
                                padding: {
                                  md: "1rem",
                                  sm: "1.5rem",
                                  xs: "1.5rem",
                                },
                                display: "flex",
                                justifyContent: "center",
                                alighnItems: "center",
                                marginLeft: "1rem",
                              }}
                            >
                              <img
                                src={
                                  actionListOpen || actionExpanded
                                    ? `${imageBaseURL}/Svg/hoverActionsIcon/actionUpArrow.svg`
                                    : `${imageBaseURL}/Svg/rightAngle.svg`
                                }
                                style={{
                                  maxWidth: actionListOpen ? "14px" : "12px",
                                }}
                                alt="right icon action"
                                loading="lazy"
                              />
                            </Box>
                          </AccordionSummary>

                          <AccordionDetails
                            sx={{
                              bgcolor: "white",
                              borderRadius:
                                actionListOpen || actionExpanded
                                  ? "0 0 4px 4px"
                                  : "4px 0 0 4px",
                              paddingLeft: "22px",
                            }}
                          >
                            <Grid container sx={{ margin: 0 }} rowSpacing={2}>
                              {actionList?.map((value, index) => {
                                let label =
                                  value?.label === "Hold / Unhold"
                                    ? isHold
                                      ? "Unhold"
                                      : "Hold"
                                    : value?.label;
                                return (
                                  <Grid
                                    className={style.actionBox}
                                    item
                                    md={
                                      actionList?.length === 2
                                        ? 6
                                        : actionList?.length === 3
                                          ? 4
                                          : actionList?.length === 1
                                            ? 12
                                            : 3
                                    }
                                    sx={{
                                      paddingTop: [0, 1, 2, 3].includes(index)
                                        ? "0px !important"
                                        : "24px",
                                      position: "relative",
                                    }}
                                    key={value?.label}
                                  >
                                    <Box
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        marginLeft: "10px",
                                        width: "100%",
                                      }}
                                      onMouseEnter={() => onMouseEnter(value)}
                                      onMouseLeave={() => onMouseLeave(value)}
                                    >
                                      <img
                                        src={
                                          value?.label === hoverItem?.label
                                            ? value?.hoverIcon
                                            : value?.icon
                                        }
                                        alt={value?.label}
                                        loading="lazy"
                                        style={{
                                          position: "absolute",
                                          left: "0px",
                                        }}
                                      />
                                      <Box
                                        className={style.actionBlocks}
                                        sx={{
                                          background:
                                            value?.label === hoverItem?.label
                                              ? "rgba(228, 33, 37, 0.08)"
                                              : "white",
                                        }}
                                        onClick={(e) =>
                                          onClickHandler(e, value?.label)
                                        }
                                      >
                                        <Box
                                          sx={
                                            value?.label === "Investigation Type" ||
                                            value?.label === "Investigation Report" ||
                                            value?.label === "Investigation Details"
                                              ? {
                                                  whiteSpace: "nowrap",
                                                  minWidth: "200px",
                                                }
                                              : isTabView
                                                ? {
                                                    whiteSpace: "nowrap",
                                                  }
                                                : actionListOpen || actionExpanded
                                                  ? {
                                                      whiteSpace: "nowrap",
                                                      overflow: "hidden",
                                                      textOverflow: "ellipsis",
                                                    }
                                                  : {}
                                          }
                                        >
                                          {label}
                                        </Box>
                                      </Box>
                                    </Box>
                                  </Grid>
                                );
                              })}
                            </Grid>
                          </AccordionDetails>
                        </Accordion>
                      )
                    )}
                  </Box>
                </>
              )}
              {/* )} */}
            </Box>
          </Fade>
        )}
      </Popper>
    </>
  );
};

export default memo(CommonPopper);
